import script from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLayout.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__